<template>
  <div>
    <highcharts :options="chartOptions" ref="lineCharts" :constructor-type="'chart'" ></highcharts>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'

HighchartsMore(Highcharts)
export default {
  name: 'PointChart',
  components: {
    highcharts: Chart
  },
  props: ['options'],
  data () {
    return {
      chartOptions: Highcharts.merge(this.options, {
        chart: {
          height: 280
        },
        title: {
          text: '',
          style: {
            fontWeight: 'bold',
            fontSize: '30px',
          },
          textAlign: 'right',
          x: 500,
          legend: {
            symbolRadius: 0,
            enabled: false
          }
        },
        plotOptions: {
          area: {
          },
          series:{
            fillOpacity: 0.4,
            dataLabels: {
              enabled: true
            }
          }
        },
        yAxis: {
          title: {
            enabled: true,
            style: {
              fontSize: '24px'
            },
            rotation: 0,
            align: 'low',
            y: 40,
            x: -20

          },
          labels: {
            style: {
            }
          }

        },
        tooltip: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'category'
        },
        credits: { enabled: false },
        colors: ['#f28219', '#605ca8'],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                enabled: false,
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
              },
              title: {
                verticalAlign: 'middle',
                align: 'center',
                floating: false,
                y: 18,
                x: -40
              }
            }
          }]
        }
      })
    }
  }
}

</script>

<style scoped>

</style>
